import script from "./saleOption.vue?vue&type=script&setup=true&lang=js"
export * from "./saleOption.vue?vue&type=script&setup=true&lang=js"

import "./saleOption.vue?vue&type=style&index=0&id=56b8d8c5&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b8d8c5"]])

export default __exports__